<div style="margin-top:5%">
  <h4 class="text-center">CONSUMER CLAIM FORM</h4>
</div>

<div class="container" style="border:1px solid #bebaba">

  <div class="row" style="margin-top:3%">
    <div class="col-md-12" style="text-align: justify; text-justify: distribute-all-lines">
      <b>
        Attention: Only fill out this form if you are a Consumer and do not plan to submit a paper form. Please note that you will not be able to
        save a partially completed claim form and return to it later.
      </b> Once you have pressed the “SUBMIT” button at the bottom of the claim form,
      you will no longer be able to make online alterations to your submission. If you need to update information on your submitted form, please
      contact the Claims Administrator at <a href="mailto:info@GenericDrugsEndPayerSettlement.com">info@GenericDrugsEndPayerSettlement.com</a>.
      <br /><br />

      <b>This form is NOT for Third-Party Payers.</b> If you are a Third-Party Payer, please fill out the Third-Party Payer Claim Form,
      available <a href="/tpp-instructions">here</a>. <br /><br />

      <b>Important</b>: Some users may experience difficulty accessing or submitting the online Claim Form from a mobile device due to
      network or security restrictions. If you encounter issues, please try using a desktop or laptop computer, a different browser, a
      private Wi-Fi connection, or disabling any VPN/proxy service. If problems persist, please contact the Claims Administrator for
      assistance. A paper Claim Form is also available for download along with instructions on how to file a claim by mail are located
      on the <a [routerLink]="['/consumer-instructions']">File a Claim Information</a> page of this website.<br /><br />
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12">
      <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()" autocomplete="off" novalidate #formRef="ngForm">

        <div class="row lightgraybackground">
          <div class="col-md-12 text-center">
            Section A: Claimant Identification
          </div>
        </div>
        <div class="row rowformat mt-4">
          <div class="col-md-12">
            <div class="form-group">
              <label for="name1"><b>Claimant’s Name:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <input type="text" class="form-control" formControlName="name1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name1.errors }" />
              <div *ngIf="submitted && f.name1.errors" class="invalid-feedback">
                <div *ngIf="f.name1.errors.required">This field is required</div>
                <div *ngIf="f.name1.errors.maxlength">This field must not be greater than 50 characters</div>
                <div *ngIf="f.name1.errors.minlength">This field must be at least 2 characters</div>
                <div *ngIf="f.name1.errors.pattern">
                  Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row rowformat">
          <div class="col-md-12">
            <div class="form-group">
              <label for="name2"><b>Agent/Legal Representative (if any):</b></label>
              <input type="text" class="form-control" formControlName="name2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name2.errors }" />
              <div *ngIf="submitted && f.name2.errors" class="invalid-feedback">
                <div *ngIf="f.name2.errors.maxlength">This field must not be greater than 50 characters</div>
                <div *ngIf="f.name2.errors.minlength">This field must be at least 2 characters</div>
                <div *ngIf="f.name2.errors.pattern">
                  Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row rowformat">
          <div class="col-md-12">
            <div class="form-group">
              <label for="street1"><b>Street Address 1:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <input type="text" class="form-control" formControlName="street1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
              <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
                <div *ngIf="f.street1.errors.required">This field is required</div>
                <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
                <div *ngIf="f.street1.errors.maxlength">This field must not be greater than 50 characters</div>
                <div *ngIf="f.street1.errors.pattern">
                  Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row rowformat">
          <div class="col-md-12">
            <div class="form-group">
              <label for="street2"><b>Street Address 2:</b></label>
              <input type="text" class="form-control" formControlName="street2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street2.errors }" />
              <div *ngIf="submitted && f.street2.errors" class="invalid-feedback">
                <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
                <div *ngIf="f.street2.errors.maxlength">This field must not be greater than 50 characters</div>
                <div *ngIf="f.street2.errors.pattern">
                  Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row rowformat">
          <div class="col-md-4">
            <div class="form-group">
              <label for="city"><b>City:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
              <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                <div *ngIf="f.city.errors.required">This field is required</div>
                <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                <div *ngIf="f.city.errors.maxlength">This field must not be greater than 40 characters</div>
                <div *ngIf="f.city.errors.pattern">
                  Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="state"><b>State:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                <option value="">Please Select A State</option>
                <option *ngFor="let allstate of allStates">
                  {{allstate.Name}}
                </option>
              </select>
              <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                <div *ngIf="f.state.errors.required">This field is required</div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="zip"><b>Zip Code:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
              <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
                <div *ngIf="f.zip.errors.required">This field is required</div>
                <div *ngIf="f.zip.errors.pattern">
                  US zip Code with format 99999 or 99999-9999 alone are accepted
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="labelBoldWeight" style="font-weight:bold" for="primaryPhone">Primary Phone Number:<span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="primaryPhone" placeholder="XXX-XXX-XXXX (No dashes)" autocomplete="no" trim="blur"
                     [ngClass]="{ 'is-invalid': f.primaryPhone.errors }" />
              <div *ngIf="f.primaryPhone.errors" class="invalid-feedback">
                <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be greater than 10 digits</div>
                <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="labelBoldWeight" style="font-weight:bold" for="primaryPhoneType">Primary Phone Type:<span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': f.primaryPhoneType.errors }">
                <option value="">Please Select Phone Type</option>
                <option value="Cell">Mobile</option>
                <option value="Land">Landline</option>
              </select>
              <div *ngIf="f.primaryPhoneType.errors" class="custom-error">
                <div *ngIf="f.primaryPhoneType.errors.required">This field is required</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row rowformat">
          <div class="col-md-12">
            <div class="form-group">
              <label for="emailAddress"><b>Email Address:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }" />
              <div *ngIf="submitted && f.emailAddress.errors" class="invalid-feedback">
                <div *ngIf="f.emailAddress.errors.maxlength">This field must not be at greater 255 characters</div>
                <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                <div *ngIf="f.emailAddress.errors.required">This field is required</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row rowformat">
          <div class="col-md-12">
            <sup>*</sup>By providing your email address, you authorize the Claims Administrator to use it to send you information about this claim. Neither your phone number nor your email will be disseminated or used beyond what is needed for these Settlements.
          </div>
        </div>
        <br />
        <div class="row lightgraybackground">
          <div class="col-md-12 text-center">
            Section B: Form of Payment
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">

            Please select your form of payment:<br /><br />

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="ACH">
                    <label class="form-check-label" for="1">
                      <b>ACH</b><br /><br />

                      By selecting ACH (Direct Deposit), I verify that the name on the account is the same name as on this claim. Please check the box next to checking
                      OR savings and provide your routing number and account number in the provided boxes:<br /><br />
                    </label>
                  </div>
                  <div *ngIf="showDivACH == true">
                    <div class="row rowformat">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="achAccountType"><b>Account Type:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                          <select class="form-control" formControlName="achAccountType" [ngClass]="{ 'is-invalid': f.achAccountType.errors }">
                            <option value="">Please select an account type</option>
                            <option value="Checking">Checking</option>
                            <option value="Savings">Savings</option>
                          </select>
                          <div *ngIf="f.achAccountType.errors" class="invalid-feedback">
                            <div *ngIf="f.achAccountType.errors.required">This field is required</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row rowformat">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="achRoutingNumber"><b>9-Digit Routing Number:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                          <input type="text" class="form-control" formControlName="achRoutingNumber" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.achRoutingNumber.errors }" />
                          <div *ngIf="f.achRoutingNumber.errors" class="invalid-feedback">
                            <div *ngIf="f.achRoutingNumber.errors.required">This field is required</div>
                            <div *ngIf="f.achRoutingNumber.errors.maxlength">This field must not be greater than 9 digits</div>
                            <div *ngIf="f.achRoutingNumber.errors.minlength">This field must be at least 9 digits</div>
                            <div *ngIf="f.achRoutingNumber.errors.pattern">Only use Digits 0-9</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="achAccountNumber"><b>Account Number:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                          <input type="text" class="form-control" formControlName="achAccountNumber" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.achAccountNumber.errors }" />
                          <div *ngIf="f.achAccountNumber.errors" class="invalid-feedback">
                            <div *ngIf="f.achAccountNumber.errors.required">This field is required</div>
                            <div *ngIf="f.achAccountNumber.errors.maxlength">This field must not be greater than 17 digits</div>
                            <div *ngIf="f.achAccountNumber.errors.minlength">This field must be at least 4 digits</div>
                            <div *ngIf="f.achAccountNumber.errors.pattern">Only use Digits 0-9</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="Zelle">
                    <label class="form-check-label" for="2">
                      <b>Zelle</b><br /><br />

                      By selecting Zelle, I agree that the information necessary to receive payment from this vendor (e.g., email address, phone number) is
                      the same as the information provided in Section A above.<br /><br />
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="PayPal">
                    <label class="form-check-label" for="3">
                      <b>PayPal</b><br /><br />

                      By selecting PayPal, I agree that the information necessary to receive payment from this vendor (e.g., email address, phone number) is the same as the
                      information provided in Section A above.<br /><br />
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="Venmo">
                    <label class="form-check-label" for="4">
                      <b>Venmo</b><br /><br />

                      By selecting Venmo, I agree that the information necessary to receive payment from this vendor (e.g., email address, phone number) is the same as the
                      information provided in Section A above.<br /><br />
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="optPaymentRadio" formControlName="optPaymentRadio" id="1" (change)="getPaymentRadioValue($event)" value="Paper Check">
                    <label class="form-check-label" for="5">
                      <b>Paper Check</b><br /><br />

                      By selecting Paper Check, I understand that a check will be mailed to the name and address provided in Section A above.<br /><br />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div class="row lightgraybackground">
              <div class="col-md-12 text-center">
                Section C: Should I File a Claim?
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                To be eligible to file a claim and receive a cash distribution from the Settlements, you must be a member of the EPP Sandoz Settlement
                Class and/or the EPP Sun/Taro Settlement Class. Those classes include:<br /><br />

                <p class="row" style="margin-left: 7%; margin-right: 7%">
                  All persons and entities in each of the 50 United States (except Indiana and Ohio), as well as the District of Columbia, Puerto Rico
                  and the U.S. Virgin Islands, that indirectly purchased, paid and/or provided reimbursement for some or all of the purchase price for
                  any Named Generic Drugs, other than for resale, from May 1, 2009 through December 31, 2019.<br /><br />
                </p>

                The list of Named Generic Drugs is attached as <a href="../../../assets/Docs/2026/Drug List for Claim Form (2026-07-30).pdf" target="_blank">HERE</a>.<br /><br />

                <!--To find out if a drug you purchased is included in the settlement, review the list of drugs <a href="../../../assets/Docs/2026/NDC List 7.10.26.pdf" target="_blank">HERE</a>.<br /><br />-->

                <!--or

  Use the Drug Lookup Tool below<br /><br />-->
                Certain groups of people are not eligible to file a claim form or receive a cash distribution from the Settlements, even if they otherwise meet the
                definition above. <b>The EPP Sandoz Settlement Class and the EPP Sun/Taro Settlement Class do <u>not</u> include the following Consumers</b>:<br /><br />


                •	Defendants’ officers, directors, management, employees, subsidiaries, and affiliates;<br />
                •	Consumers who were covered by Medicaid for their purchases of Named Generic Drugs;<br />
                •	Judges assigned to this case and any members of their immediate families;<br />
                •	Persons who only purchased Defendants’ Named Generic Drugs for purposes of resale or directly from Defendants; and<br />
                •	Individuals who requested to be excluded from the EPP Sandoz Settlement Class or the EPP Sun/Taro Settlement Class. (Note that the deadline for requesting exclusion has passed.)<br /><br />

                The list of Defendants is <a href="../../../assets/Docs/2026/List of Defendants.pdf" target="_blank">HERE</a>.

              </div>
            </div>
            <br />
            <div class="row lightgraybackground">
              <div class="col-md-12 text-center">
                Class Member Confirmation
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="form-group form-check">
                  <input type="checkbox" formControlName="classMemberConfirmation" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.classMemberConfirmation.errors }" ngModel required />
                  <label for="classMemberConfirmation" style="font-size:1.5em">
                    <b><u>By checking this box, I confirm that I have read the definition of the Class and I am a Class Member.</u></b>
                    <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                  </label>
                  <div *ngIf="f.classMemberConfirmation.errors" class="invalid-feedback">
                    <div *ngIf="f.classMemberConfirmation.errors.required">Please Add a Checkmark in the Box Above</div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row lightgraybackground">
              <div class="col-md-12 text-center">
                Section D: Purchase Information
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                Enter your purchase information by clicking the “Add My Purchase Information” button. List only the Named Generic Drugs that you purchased
                from May 1, 2009 to December 31, 2019..<br /><br />

                <i>
                  (From the drop-down list, select the name of the drug and the total amount you paid out-of-pocket for that drug during May 1, 2009
                through December 31, 2019. List the total amount that you paid for the drug, not the amount that your insurer paid. For example,
                Albuterol, $100. If you purchased multiple formulations of a drug, enter the combined total that you spent on all of those formulations.
                Click the “Add My Purchase Information” to add additional drug names.)
                </i><br /><br />
              </div>
            </div>

            <div class="card card-body bg-light">
              <div class="row mb-3">
                <div class="col-md-6">
                  <button type="button" (click)="addpurchaseInformationData()" class="btn btn-primary btn-sm">Add My Purchase Information</button>
                </div>
              </div>
              <div formArrayName="purchaseInformation" *ngFor="let purchaseInformations of purchaseInformation().controls; let i = index">
                <div [formGroupName]="i">
                  <div style="border: 1px solid black; padding-left: 1%; padding-right: 1%; padding-top: 1%; padding-bottom: 1%">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="genericDrugNameAndListNumber">Drug Name:</label>
                          <select class="form-control" formControlName="genericDrugNameAndListNumber"
                                  [ngClass]="{'is-invalid': purchaseInformationsARR(i).controls['genericDrugNameAndListNumber'].errors && (purchaseInformationsARR(i).controls['genericDrugNameAndListNumber'].dirty ||
           purchaseInformationsARR(i).controls['genericDrugNameAndListNumber'].touched || purchaseInformationsARR(i).controls['genericDrugNameAndListNumber'].pristine)}">
                            <option value="">Select Drug Name</option>
                            <option value="ACETAZOLAMIDE">ACETAZOLAMIDE</option>
                            <option value="ADAPALENE">ADAPALENE</option>
                            <option value="ALBUTEROL">ALBUTEROL</option>
                            <option value="ALCLOMETASONE DIPROPIONATE">ALCLOMETASONE DIPROPIONATE</option>
                            <option value="ALLOPURINOL">ALLOPURINOL</option>
                            <option value="AMANTADINE HCL">AMANTADINE HCL</option>
                            <option value="AMILORIDE HCL/HCTZ">AMILORIDE HCL/HCTZ</option>
                            <option value="AMITRIPTYLINE">AMITRIPTYLINE</option>
                            <option value="AMMONIUM LACTATE">AMMONIUM LACTATE</option>
                            <option value="AMOXICILLIN/CLAVULANATE POTASSIUM">AMOXICILLIN/CLAVULANATE POTASSIUM</option>
                            <option value="AMPHETAMINE/DEXTROAMPHETAMINE (MAS) (ADDERALL)">AMPHETAMINE/DEXTROAMPHETAMINE (MAS) (ADDERALL)</option>
                            <option value="ATENOLOL/CHLORTHALIDONE">ATENOLOL/CHLORTHALIDONE</option>
                            <option value="ATROPINE SULFATE">ATROPINE SULFATE</option>
                            <option value="AZITHROMYCIN">AZITHROMYCIN</option>
                            <option value="BACLOFEN">BACLOFEN</option>
                            <option value="BALSALAZIDE DISODIUM">BALSALAZIDE DISODIUM</option>
                            <option value="BENAZEPRIL HCTZ">BENAZEPRIL HCTZ</option>
                            <option value="BETAMETHASONE DIPROPIONATE">BETAMETHASONE DIPROPIONATE</option>
                            <option value="BETAMETHASONE DIPROPIONATE AUGMENTED">BETAMETHASONE DIPROPIONATE AUGMENTED</option>
                            <option value="BETAMETHASONE DIPROPIONATE/CLOTRIMAZOLE">BETAMETHASONE DIPROPIONATE/CLOTRIMAZOLE</option>
                            <option value="BETAMETHASONE VALERATE">BETAMETHASONE VALERATE</option>
                            <option value="BETHANECHOL CHLORIDE">BETHANECHOL CHLORIDE</option>
                            <option value="BROMOCRIPTINE MESYLATE">BROMOCRIPTINE MESYLATE</option>
                            <option value="BUDESONIDE">BUDESONIDE</option>
                            <option value="BUMETANIDE">BUMETANIDE</option>
                            <option value="BUSPIRONE HCL">BUSPIRONE HCL</option>
                            <option value="BUTORPHANOL TARTRATE">BUTORPHANOL TARTRATE</option>
                            <option value="CABERGOLINE">CABERGOLINE</option>
                            <option value="CALCIPOTRIENE">CALCIPOTRIENE</option>
                            <option value="CALCIPOTRIENE BETHAMASONE DIPROPRIONATE">CALCIPOTRIENE BETHAMASONE DIPROPRIONATE</option>
                            <option value="CAPECITABINE">CAPECITABINE</option>
                            <option value="CAPTOPRIL">CAPTOPRIL</option>
                            <option value="CARBAMAZEPINE">CARBAMAZEPINE</option>
                            <option value="CARISOPRODOL">CARISOPRODOL</option>
                            <option value="CEFDINIR">CEFDINIR</option>
                            <option value="CEFPODOXIME PROXETIL">CEFPODOXIME PROXETIL</option>
                            <option value="CEFPROZIL">CEFPROZIL</option>
                            <option value="CEFUROXIME AXETIL">CEFUROXIME AXETIL</option>
                            <option value="CELECOXIB">CELECOXIB</option>
                            <option value="CEPHALEXIN (CEFALEXIN)">CEPHALEXIN (CEFALEXIN)</option>
                            <option value="CHLORPROMAZINE HCL">CHLORPROMAZINE HCL</option>
                            <option value="CHOLESTYRAMINE">CHOLESTYRAMINE</option>
                            <option value="CICLOPIROX">CICLOPIROX</option>
                            <option value="CIMETIDINE">CIMETIDINE</option>
                            <option value="CIPROFLOXACIN HCL">CIPROFLOXACIN HCL</option>
                            <option value="CLARITHROMYCIN ER">CLARITHROMYCIN ER</option>
                            <option value="CLEMASTINE FUMARATE">CLEMASTINE FUMARATE</option>
                            <option value="CLINDAMYCIN PHOSPHATE">CLINDAMYCIN PHOSPHATE</option>
                            <option value="CLOBETASOL">CLOBETASOL</option>
                            <option value="CLOMIPRAMINE">CLOMIPRAMINE</option>
                            <option value="CLONIDINE">CLONIDINE</option>
                            <option value="CLOTRIMAZOLE">CLOTRIMAZOLE</option>
                            <option value="CYPROHEPTADINE HCL">CYPROHEPTADINE HCL</option>
                            <option value="DESMOPRESSIN ACETATE">DESMOPRESSIN ACETATE</option>
                            <option value="DESONIDE">DESONIDE</option>
                            <option value="DESOXIMETASONE">DESOXIMETASONE</option>
                            <option value="DEXMETHYLPHENIDATE HCL ER (DEXMETH ER) (FOCALIN)">DEXMETHYLPHENIDATE HCL ER (DEXMETH ER) (FOCALIN)</option>
                            <option value="DEXTROAMPHETAMINE SULFATE (DEX SULFATE)">DEXTROAMPHETAMINE SULFATE (DEX SULFATE)</option>
                            <option value="DICLOFENAC POTASSIUM">DICLOFENAC POTASSIUM</option>
                            <option value="DICLOXACILLIN SODIUM">DICLOXACILLIN SODIUM</option>
                            <option value="DIFLUNISAL">DIFLUNISAL</option>
                            <option value="DIGOXIN">DIGOXIN</option>
                            <option value="DILTIAZEM HCL">DILTIAZEM HCL</option>
                            <option value="DIPHENOXYLATE/ATROPINE">DIPHENOXYLATE/ATROPINE</option>
                            <option value="DISOPYRAMIDE PHOSPHATE">DISOPYRAMIDE PHOSPHATE</option>
                            <option value="DIVALPROEX ER">DIVALPROEX ER</option>
                            <option value="DOXAZOSIN MESYLATE">DOXAZOSIN MESYLATE</option>
                            <option value="DOXYCYCLINE HYCLATE">DOXYCYCLINE HYCLATE</option>
                            <option value="DROSPIRENONE/ETHINYL ESTRADIOL (OCELLA)">DROSPIRENONE/ETHINYL ESTRADIOL (OCELLA)</option>
                            <option value="ECONAZOLE">ECONAZOLE</option>
                            <option value="ENALAPRIL MALEATE">ENALAPRIL MALEATE</option>
                            <option value="ENTECAVIR">ENTECAVIR</option>
                            <option value="EPLERENONE">EPLERENONE</option>
                            <option value="ERYTHROMYCIN">ERYTHROMYCIN</option>
                            <option value="ESTAZOLAM">ESTAZOLAM</option>
                            <option value="ESTRADIOL">ESTRADIOL</option>
                            <option value="ESTRADIOL/NORETHINDRONE ACETATE (MIMVEY)">ESTRADIOL/NORETHINDRONE ACETATE (MIMVEY)</option>
                            <option value="ETHAMBUTOL HCL">ETHAMBUTOL HCL</option>
                            <option value="ETHINYL ESTRADIOL/DESOGESTREL [KARIVA]">ETHINYL ESTRADIOL/DESOGESTREL [KARIVA]</option>
                            <option value="ETHINYL ESTRADIOL/LEVONORGESTREL (PORTIA,JOLESSA)">ETHINYL ESTRADIOL/LEVONORGESTREL (PORTIA,JOLESSA)</option>
                            <option value="ETHOSUXIMIDE">ETHOSUXIMIDE</option>
                            <option value="ETODOLAC">ETODOLAC</option>
                            <option value="EXEMESTANE">EXEMESTANE</option>
                            <option value="FENOFIBRATE">FENOFIBRATE</option>
                            <option value="FLUCONAZOLE">FLUCONAZOLE</option>
                            <option value="FLUOCINOLONE ACETONIDE">FLUOCINOLONE ACETONIDE</option>
                            <option value="FLUOCINONIDE">FLUOCINONIDE</option>
                            <option value="FLUOXETINE HCL">FLUOXETINE HCL</option>
                            <option value="FLURBIPROFEN">FLURBIPROFEN</option>
                            <option value="FLUTAMIDE">FLUTAMIDE</option>
                            <option value="FLUTICASONE PROPIONATE">FLUTICASONE PROPIONATE</option>
                            <option value="FLUVASTATIN SODIUM">FLUVASTATIN SODIUM</option>
                            <option value="FOSINOPRIL HCTZ">FOSINOPRIL HCTZ</option>
                            <option value="GABAPENTIN">GABAPENTIN</option>
                            <option value="GLIMEPIRIDE">GLIMEPIRIDE</option>
                            <option value="GLIPIZIDE/METFORMIN">GLIPIZIDE/METFORMIN</option>
                            <option value="GLYBURIDE">GLYBURIDE</option>
                            <option value="GLYBURIDE/METFORMIN">GLYBURIDE/METFORMIN</option>
                            <option value="GRISEOFULVIN">GRISEOFULVIN</option>
                            <option value="HALOBETASOL PROPIONATE">HALOBETASOL PROPIONATE</option>
                            <option value="HALOPERIDOL">HALOPERIDOL</option>
                            <option value="HYDRALAZINE HCL">HYDRALAZINE HCL</option>
                            <option value="HYDROCORTISONE ACETATE">HYDROCORTISONE ACETATE</option>
                            <option value="HYDROCORTISONE VALERATE">HYDROCORTISONE VALERATE</option>
                            <option value="HYDROXYUREA">HYDROXYUREA</option>
                            <option value="HYDROXYZINE PAMOATE">HYDROXYZINE PAMOATE</option>
                            <option value="IMIQUIMOD">IMIQUIMOD</option>
                            <option value="IRBESARTAN">IRBESARTAN</option>
                            <option value="ISONIAZID">ISONIAZID</option>
                            <option value="ISOSORBIDE DINITRATE">ISOSORBIDE DINITRATE</option>
                            <option value="KETOCONAZOLE">KETOCONAZOLE</option>
                            <option value="KETOPROFEN">KETOPROFEN</option>
                            <option value="KETOROLAC TROMETHAMINE">KETOROLAC TROMETHAMINE</option>
                            <option value="LABETALOL HCL">LABETALOL HCL</option>
                            <option value="LAMIVUDINE/ZIDOVUDINE (COMBIVIR)">LAMIVUDINE/ZIDOVUDINE (COMBIVIR)</option>
                            <option value="LATANOPROST">LATANOPROST</option>
                            <option value="LEFLUNOMIDE">LEFLUNOMIDE</option>
                            <option value="LEVOTHYROXINE">LEVOTHYROXINE</option>
                            <option value="LIDOCAINE HCL">LIDOCAINE HCL</option>
                            <option value="LIDOCAINE/PRILOCAINE">LIDOCAINE/PRILOCAINE</option>
                            <option value="LOPERAMIDE HCL">LOPERAMIDE HCL</option>
                            <option value="MEDROXYPROGESTERONE ACETATE">MEDROXYPROGESTERONE ACETATE</option>
                            <option value="MEPROBAMATE">MEPROBAMATE</option>
                            <option value="METFORMIN (F) ER">METFORMIN (F) ER</option>
                            <option value="METHADONE HCL">METHADONE HCL</option>
                            <option value="METHAZOLAMIDE">METHAZOLAMIDE</option>
                            <option value="METHIMAZOLE">METHIMAZOLE</option>
                            <option value="METHOTREXATE">METHOTREXATE</option>
                            <option value="METHYLPHENIDATE">METHYLPHENIDATE</option>
                            <option value="METHYLPREDNISOLONE">METHYLPREDNISOLONE</option>
                            <option value="METRONIDAZOLE">METRONIDAZOLE</option>
                            <option value="MOEXIPRIL HCL">MOEXIPRIL HCL</option>
                            <option value="MOEXIPRIL HCL/HCTZ">MOEXIPRIL HCL/HCTZ</option>
                            <option value="MOMETASONE FUROATE">MOMETASONE FUROATE</option>
                            <option value="NABUMETONE">NABUMETONE</option>
                            <option value="NADOLOL">NADOLOL</option>
                            <option value="NAFCILLIN SODIUM">NAFCILLIN SODIUM</option>
                            <option value="NAPROXEN SODIUM">NAPROXEN SODIUM</option>
                            <option value="NEOMYCIN/POLYMYXIN/HYDROCORTISONE">NEOMYCIN/POLYMYXIN/HYDROCORTISONE</option>
                            <option value="NIACIN ER">NIACIN ER</option>
                            <option value="NIMODIPINE">NIMODIPINE</option>
                            <option value="NITROFURANTOIN/MACROCRYSTALLINE">NITROFURANTOIN/MACROCRYSTALLINE</option>
                            <option value="NORETHINDRONE ACETATE">NORETHINDRONE ACETATE</option>
                            <option value="NORETHINDRONE/ETHINYL ESTRADIOL (BALZIVA)">NORETHINDRONE/ETHINYL ESTRADIOL (BALZIVA)</option>
                            <option value="NORTRIPTYLINE HCL">NORTRIPTYLINE HCL</option>
                            <option value="NYSTATIN">NYSTATIN</option>
                            <option value="NYSTATIN/TRIAMCINOLONE">NYSTATIN/TRIAMCINOLONE</option>
                            <option value="OMEGA 3 ACID ETHYL ESTERS">OMEGA 3 ACID ETHYL ESTERS</option>
                            <option value="OXACILLIN SODIUM">OXACILLIN SODIUM</option>
                            <option value="OXAPROZIN">OXAPROZIN</option>
                            <option value="OXYBUTYNIN CHLORIDE">OXYBUTYNIN CHLORIDE</option>
                            <option value="OXYCODONE/ACETAMINOPHEN">OXYCODONE/ACETAMINOPHEN</option>
                            <option value="OXYCODONE HCL">OXYCODONE HCL</option>
                            <option value="PARICALCITOL">PARICALCITOL</option>
                            <option value="PAROMOMYCIN">PAROMOMYCIN</option>
                            <option value="PENICILLIN V POTASSIUM">PENICILLIN V POTASSIUM</option>
                            <option value="PENTOXIFYLLINE ER">PENTOXIFYLLINE ER</option>
                            <option value="PERMETHRIN">PERMETHRIN</option>
                            <option value="PERPHENAZINE">PERPHENAZINE</option>
                            <option value="PHENYTOIN SODIUM ER">PHENYTOIN SODIUM ER</option>
                            <option value="PILOCARPINE HCL">PILOCARPINE HCL</option>
                            <option value="PIOGLITAZONE METFORMIN HCL">PIOGLITAZONE METFORMIN HCL</option>
                            <option value="PIROXICAM">PIROXICAM</option>
                            <option value="POTASSIUM CHLORIDE ER">POTASSIUM CHLORIDE ER</option>
                            <option value="PRAVASTATIN">PRAVASTATIN</option>
                            <option value="PRAZOSIN HCL">PRAZOSIN HCL</option>
                            <option value="PREDNISOLONE ACETATE">PREDNISOLONE ACETATE</option>
                            <option value="PREDNISONE">PREDNISONE</option>
                            <option value="PROCHLORPERAZINE">PROCHLORPERAZINE</option>
                            <option value="PROMETHAZINE">PROMETHAZINE</option>
                            <option value="PROPRANOLOL">PROPRANOLOL</option>
                            <option value="RALOXIFENE HCL">RALOXIFENE HCL</option>
                            <option value="RANITIDINE HCL">RANITIDINE HCL</option>
                            <option value="SILVER SULFADIAZINE">SILVER SULFADIAZINE</option>
                            <option value="SPIRONOLACTONE/HCTZ">SPIRONOLACTONE/HCTZ</option>
                            <option value="TACROLIMUS">TACROLIMUS</option>
                            <option value="TAMOXIFEN CITRATE">TAMOXIFEN CITRATE</option>
                            <option value="TEMOZOLOMIDE">TEMOZOLOMIDE</option>
                            <option value="TERCONAZOLE">TERCONAZOLE</option>
                            <option value="THEOPHYLLINE ER">THEOPHYLLINE ER</option>
                            <option value="TIMOLOL MALEATE">TIMOLOL MALEATE</option>
                            <option value="TIZANIDINE HCL">TIZANIDINE HCL</option>
                            <option value="TOBRAMYCIN">TOBRAMYCIN</option>
                            <option value="TOBRAMYCIN/DEXAMETHASONE">TOBRAMYCIN/DEXAMETHASONE</option>
                            <option value="TOLMETIN SODIUM">TOLMETIN SODIUM</option>
                            <option value="TOLTERODINE TARTRATE">TOLTERODINE TARTRATE</option>
                            <option value="TOPIRAMATE">TOPIRAMATE</option>
                            <option value="TRAZODONE HCL">TRAZODONE HCL</option>
                            <option value="TRIAMCINOLONE ACETONIDE">TRIAMCINOLONE ACETONIDE</option>
                            <option value="TRIAMTERENE/HCTZ">TRIAMTERENE/HCTZ</option>
                            <option value="TRIFLUOPERAZINE HCL">TRIFLUOPERAZINE HCL</option>
                            <option value="URSODIOL">URSODIOL</option>
                            <option value="VALSARTAN HCTZ">VALSARTAN HCTZ</option>
                            <option value="VERAPAMIL">VERAPAMIL</option>
                            <option value="WARFARIN SODIUM">WARFARIN SODIUM</option>
                            <option value="ZOLEDRONIC ACID">ZOLEDRONIC ACID</option>
                          </select>
                          <div *ngFor="let validation of validation_TransactionalClaimsDataAvailableErrorMessage.genericDrugNameAndListNumber" class="invalid-feedback">
                            <div *ngIf="purchaseInformationsARR(i).controls['genericDrugNameAndListNumber'].hasError(validation.type) && (purchaseInformationsARR(i).controls['genericDrugNameAndListNumber'].dirty ||
           purchaseInformationsARR(i).controls['genericDrugNameAndListNumber'].touched || purchaseInformationsARR(i).controls['genericDrugNameAndListNumber'].pristine)">
                              {{ validation.message }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="totalAmountPaid">Total Dollar Amount ($) You Paid for the Drug from May 1, 2009 to December 31, 2019.:</label>
                          <input type="text" class="form-control" formControlName="totalAmountPaid" placeholder="" autocomplete="no" trim="blur"
                                 [ngClass]="{'is-invalid': purchaseInformationsARR(i).controls['totalAmountPaid'].errors && (purchaseInformationsARR(i).controls['totalAmountPaid'].dirty ||
                         purchaseInformationsARR(i).controls['totalAmountPaid'].touched || purchaseInformationsARR(i).controls['totalAmountPaid'].pristine)}" />
                          <div *ngFor="let validation of validation_TransactionalClaimsDataAvailableErrorMessage.totalAmountPaid" class="invalid-feedback">
                            <div *ngIf="purchaseInformationsARR(i).controls['totalAmountPaid'].hasError(validation.type) && (purchaseInformationsARR(i).controls['totalAmountPaid'].dirty ||
                        purchaseInformationsARR(i).controls['totalAmountPaid'].touched || purchaseInformationsARR(i).controls['totalAmountPaid'].pristine)">
                              {{ validation.message }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <button type="button" class="btn btn-danger" (click)="removepurchaseInformationData(i)">Remove</button>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <br />
            </div>
            <br /><br />




          </div>
        </div>
        <div class="row lightgraybackground">
          <div class="col-md-12 text-center">

            Section E: Claim Documentation and Disputes Regarding Claim Amounts

          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">

            For each drug that you listed in <i>Section D</i>, you <b>must</b> upload a file with a scan or image of a document (a “Proof of Payment”) showing that you purchased that drug <u>at least once</u>
            from May 1, 2009 to December 31, 2019. (For example, if you listed Albuterol and Doxycyline in Section D, then you must upload a document(s) showing at least
            one purchase of Albuterol and at least one purchase of Doxycycline.)<br /><br />

            To upload your documents, click on the “Upload Your Documents” button below.<br/><br/>

            Acceptable Proofs of Payment include copies of the following:<br /><br />

            <p class="row" style="margin-left: 7%; margin-right: 7%">
              •	Receipts or invoices identifying the drug that was purchased,<br />
              •	Account statements identifying the drug that was purchased,<br />
              •	An itemized record of your purchases that your pharmacy has provided at your request, and<br />
              •	Other records showing that you purchased the drug between May 1, 2009 and December 31, 2019 and the dollar amount that you paid.<br /><br />
            </p>
            <div class="row">
              <div class="col-md-4"></div>

              <div class="col-md-4">
                <input type="file" id="file" #fileInput (change)="getFileDetails($event)" multiple class="form-control form-control-sm hidden" />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<label for="file" class="btn btn-primary btn-sm">Upload Your Documents</label>
                <br />
              </div>
              <div class="col-md-4"></div>

            </div>
            <br />
            <div class="row">
              <div class="col-sm-12">
                <table class="table" #listofFiles>
                  <thead>
                    <tr>
                      <th>Files To Be Uploaded</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let sd of supportingDocuments; let i = index">
                      <td class="hidden">{{i}}</td>
                      <td>{{sd.name}}</td>
                      <td>
                        <button type="button" class="btn btn-danger"
                                (click)="removeRow(i)">
                          Remove
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>


            <b><u>Note</u></b>: Keep all records of all your Named Generic Drug purchases.
            The Claims Administrator may ask you to provide additional supporting documents after you submit your claim form. Claims may be audited and rejected because
            of an inadequate proof of purchase, suspected fraud, or potentially inaccurate amounts, based on expected average purchases.<br /><br />

            If the Claims Administrator rejects or reduces your claim and you believe the rejection or reduction is in error, you may contact the Claims Administrator
            within 14 days of the rejection or reduction notice to ask for an additional review. You must submit any additional documentation and arguments at that time.
            If the Claims Administrator and Settlement Class Counsel cannot resolve the dispute about your claim, you may ask the Court to review your claim.<br /><br />

            To request Court review, you must send the Claims Administrator a signed written statement (via U.S. Mail at  In re: Generic Pharmaceuticals Pricing
            Antitrust Litigation – End-Payer Settlement, P.O. Box 173118, Milwaukee, Wisconsin 53217, or via email at
            <a href="mailto:info@GenericDrugsEndPayerSettlement.com">info@GenericDrugsEndPayerSettlement.com</a>) that (a) states the reasons you contest (or disagree with) the rejection or payment determination regarding your claim; and (b)
            specifically states that you “request that the Court review the determination regarding this claim.” You must include all documents supporting your
            argument(s). Your request must be postmarked or emailed no later than 21 days after the Claims Administrator’s response to your request for Claims
            Administrator review. The Claims Administrator and Settlement Class Counsel will present the dispute to the Court for review, so your claim and any
            supporting documents may be publicly available once filed with the Court. The Court may refer your dispute to a Special Master; if it does, you may
            be required to pay 50% of the Special Master’s fee.
          </div>
          </div>

        <br /><br />
        <div class="row lightgraybackground">
          <div class="col-md-12 text-center">
            Section F: Certification
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            I have read and am familiar with the contents of the instructions accompanying this claim form. I certify that the information
            I provided above and any documents uploaded by me are true, correct, and complete to the best of my knowledge. I certify that
            I, or the Class Member I represent, purchased one or more Named Generic Drugs between May 1, 2009 and December 31, 2019 in one
            of the 50 United States (except Indiana and Ohio), or the District of Columbia, Puerto Rico, or the U.S. Virgin Islands. I
            further certify that those purchase(s) were not made directly from the Defendants or for the purposes of resale.<br /><br />

            In addition, I certify that I, or the Class Member I represent, is not: (a) an officer, director, manager or employee of a
            Defendant; or (b) a consumer who was covered by Medicaid for all of their purchases of Named Generic Drugs;<br /><br />

            I also certify I have provided all the information requested above to the extent I, or the Class Member I represent, have access to it.<br /><br />

            I further certify that I have not submitted data for Named Generic Drugs that I purchased directly from a Defendant or for Named
            Generic Drugs that I later resold.<br /><br />

            To the extent I have been given authority to submit this claim form by a Class Member on his or her behalf, and accordingly am
            submitting this claim form in the capacity of an authorized agent of the Class Member identified on this form, and to the extent
            I have been authorized to receive on behalf of the Class Member any and all amounts that may be allocated to him or her from the
            Settlement Fund, I certify that such authority has been properly vested in me and that I will fulfill all duties I owe the Class
            Member. In the event amounts from the Settlement Fund are distributed to me and the Class Member later claims that I did not have
            the authority to claim and/or receive such amounts on his or her behalf, I and my employer will hold the EPP Sandoz Settlement
            Class, the EPP Sun/Taro Settlement Class, counsel for the EPP Settlement Classes, Settling Defendants Sandoz and Sun/Taro, and
            the Claims Administrator harmless with respect to any claims made by the Class Member.<br /><br />

            I hereby submit to the jurisdiction of the United States District Court for the Eastern District of Pennsylvania for all
            purposes connected with this claim, including resolution of disputes. I acknowledge that I may be subject to sanctions,
            including the possibility of criminal prosecution, for any false information or representations in this claim form. I
            agree to supplement this claim form and submit additional documents to prove the information in this form, if the Claims
            Administrator requests it.<br /><br />

            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="form-group form-check">
                  <input type="checkbox" formControlName="signatureConfirmation" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.signatureConfirmation.errors }" ngModel required />
                  <label for="signatureConfirmation">
                    <b><u>I certify that the above information supplied by the undersigned is true and correct to the best of my knowledge.</u></b>
                    <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                  </label>
                  <div *ngIf="f.signatureConfirmation.errors" class="invalid-feedback">
                    <div *ngIf="f.signatureConfirmation.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group">
              <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" ngDefaultControl [ngClass]="{ 'is-invalid': submitted && f.googleRecaptchaToken.errors }"></re-captcha>
              <div *ngIf="submitted && f.googleRecaptchaToken.errors">
                <div *ngIf="f.googleRecaptchaToken.errors.required" class="custom-error">This field is required</div>
              </div>
            </div>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="signature"><b>Electronic Signature:</b> <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
              <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                     trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
              <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
                <div *ngIf="f.signature.errors.required">This field is required</div>
                <div *ngIf="f.signature.errors.maxlength">This field must not be greater than 50 characters</div>
                <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
                <div *ngIf="f.signature.errors.pattern">
                  Only use letters, numbers, periods, spaces, hyphens,
                  brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <div class="row">
          <div class="col-md-12 text-center">
            <div *ngIf="showDivSubmittalErrorMessage == true" class="submittal-custom-error" style="color:red">
              Missing information or information was not entered in correctly, please review "Section A: Claimant Identification", "Section B: Class Member Confirmation", "Section C: Purchase Information",
              and "Section F: Certification", ensure all fields have been filled out correctly before attempting to submit again.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <div id="showDivSectionB" class="submittal-custom-error" style="color:red" hidden>
              Missing information, please review Section B: Should I File a Claim Form? and ensure all fields have been filled out before proceeding.
            </div>
          </div>
        </div>
        <br />
        <ul class="list-inline text-center">
          <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
        </ul>
      </form>
    </div>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
    <br />
    <br />
  </div>
</div>
